import { Comparator, LogicalOperator } from '~/constants/operators';
import SavedAPIAddress, { JSONAPIAddress } from './APIAddress';
import ParcelTemplate, { JSONParcelTemplate } from './ParcelTemplate';

type JSONBusinessRule = {
  name?: string;
  description?: string;
  rank_desc: number;
  filter_group?: JSONFilterGroup;
  object_updated: string;
  rule_type: string;
  object_id: string;
  user_parcel_template: JSONParcelTemplate;
  service_level_token: string;
  account_object_id?: string;
  sender_address?: JSONAPIAddress;
};

type BusinessRule = {
  name?: string;
  description?: string;
  objectUpdated: Date;
  rankDesc: number;
  filterGroup?: FilterGroup;
  ruleType: string;
  objectId: string;
  userParcelTemplate?: ParcelTemplate;
  serviceLevelToken?: string;
  accountObjectId?: string;
  senderAPIAddress?: SavedAPIAddress;
};

type JSONFilterGroup = {
  filter_entity: string;
  filters: JSONFilterOrClause[];
  id: number;
  object_id: string;
};

type FilterGroup = {
  filterEntity: string;
  filters: FilterOrClause[];
  id: number;
  objectId: string;
};

type JSONFilterOrClause = JSONFilter | JSONFilterClause;
type FilterOrClause = Filter | FilterClause;

// distinguish whether a (JSON)FilterOrClause represents a Filter or FilterClause
function isFilter(filterOrClause: JSONFilterOrClause | FilterOrClause): boolean {
  return !filterOrClause.hasOwnProperty('operator');
}

type JSONFilterClause = {
  operator: LogicalOperator;
  filters: JSONFilterOrClause[];
};

type FilterClause = {
  operator: LogicalOperator;
  filters: FilterOrClause[];
};

type JSONFilter = {
  comparator: Comparator;
  field: string;
  filter_values: FilterValue[];
  id: number;
};

type Filter = {
  comparator: Comparator;
  field: string;
  filterValues: FilterValue[];
  id: number;
  symbolString: string; // '< 5 lb'
  wordString: string; // 'less than 5 lb'
  value: string; // '5 lb'
  comparatorString: string; // 'less than'
};

// Used in JSONFilter because the values are unchanged
type FilterValue = {
  boolean: boolean;
  date: string;
  enum: string;
  text: string;
  value: string;
};

type ReorderRulePayload = {
  object_id: string;
  rank: number;
};

export default BusinessRule;

export {
  JSONBusinessRule,
  ReorderRulePayload,
  JSONFilterGroup,
  JSONFilterOrClause,
  JSONFilterClause,
  JSONFilter,
  FilterGroup,
  FilterOrClause,
  FilterClause,
  Filter,
  FilterValue,
  isFilter,
};
